import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import Layout from '../components/Layout';
import LineSeperator from '../components/ui/LineSeperator';
import '../stylings/AcademicCalendar.css';

const events2526 = [
  // April 2025
  { date: '2025-04-01', title: 'New Academic Session Begins', type: 'Academic' },
  { date: '2025-04-10', title: 'Mahavir Jayanti', type: 'Holiday' },
  { date: '2025-04-14', title: 'Dr. B.R. Ambedkar Jayanti', type: 'Holiday' },
  { date: '2025-04-18', title: 'Good Friday', type: 'Holiday' },
  // May 2025
  { date: '2025-05-01', title: 'Labour Day', type: 'Holiday' },
  { date: '2025-05-12', title: 'Buddha Purnima', type: 'Holiday' },
  { date: '2025-05-26', title: 'Summer Vacation Begins', type: 'Holiday' },
  // June 2025
  { date: '2025-06-07', title: 'Eid-ul-Adha (Bakrid)', type: 'Holiday' },
  { date: '2025-06-30', title: 'School Reopens After Summer Vacation', type: 'Academic' },
  // July 2025
  { date: '2025-07-06', title: 'Muharram (Ashura)', type: 'Holiday' },
  // August 2025
  { date: '2025-08-09', title: 'Raksha Bandhan', type: 'Holiday' },
  { date: '2025-08-15', title: 'Independence Day Celebration', type: 'Event' },
  { date: '2025-08-16', title: 'Janmashtami', type: 'Holiday' },
  // September 2025
  { date: '2025-09-05', title: "Eid-e-Milad-un-Nabi (Prophet's Birthday)", type: 'Holiday' },
  { date: '2025-09-05', title: "Teachers' Day Celebration", type: 'Event' },
  // October 2025
  { date: '2025-10-02', title: 'Gandhi Jayanti', type: 'Holiday' },
  { date: '2025-10-12', title: 'Dussehra (Vijaya Dashami)', type: 'Holiday' },
  { date: '2025-10-20', title: 'Diwali (Deepawali) – Vacation Begins', type: 'Holiday' },
  { date: '2025-10-25', title: 'School Reopens After Diwali', type: 'Academic' },
  // November 2025
  { date: '2025-11-05', title: 'Guru Nanak Jayanti', type: 'Holiday' },
  { date: '2025-11-14', title: "Children's Day Celebration", type: 'Event' },
  // December 2025
  { date: '2025-12-25', title: 'Christmas – Winter Vacation Begins', type: 'Holiday' },
  // January 2026
  { date: '2026-01-01', title: 'School Reopens After Winter Break', type: 'Academic' },
  { date: '2026-01-14', title: 'Makar Sankranti / Lohri', type: 'Holiday' },
  { date: '2026-01-26', title: 'Republic Day Celebration', type: 'Event' },
  // February 2026
  { date: '2026-02-26', title: 'Maha Shivratri', type: 'Holiday' },
  // March 2026
  { date: '2026-03-03', title: 'Holi', type: 'Holiday' },
  { date: '2026-03-31', title: 'Academic Session Ends', type: 'Academic' },
];

const events2627 = [
  // April 2026
  { date: '2026-04-01', title: 'New Academic Session Begins', type: 'Academic' },
  { date: '2026-04-02', title: 'Mahavir Jayanti', type: 'Holiday' },
  { date: '2026-04-03', title: 'Good Friday', type: 'Holiday' },
  { date: '2026-04-14', title: 'Dr. B.R. Ambedkar Jayanti', type: 'Holiday' },
  // May 2026
  { date: '2026-05-01', title: 'Labour Day', type: 'Holiday' },
  { date: '2026-05-27', title: 'Eid-ul-Adha (Bakrid)', type: 'Holiday' },
  { date: '2026-05-31', title: 'Buddha Purnima', type: 'Holiday' },
  { date: '2026-05-25', title: 'Summer Vacation Begins', type: 'Holiday' },
  // June 2026
  { date: '2026-06-26', title: 'Muharram (Ashura)', type: 'Holiday' },
  { date: '2026-06-29', title: 'School Reopens After Summer Vacation', type: 'Academic' },
  // August 2026
  { date: '2026-08-15', title: 'Independence Day Celebration', type: 'Event' },
  { date: '2026-08-28', title: 'Raksha Bandhan', type: 'Holiday' },
  // September 2026
  { date: '2026-09-05', title: "Teachers' Day Celebration", type: 'Event' },
  { date: '2026-09-06', title: 'Janmashtami', type: 'Holiday' },
  { date: '2026-09-24', title: "Eid-e-Milad-un-Nabi (Prophet's Birthday)", type: 'Holiday' },
  // October 2026
  { date: '2026-10-02', title: 'Gandhi Jayanti', type: 'Holiday' },
  { date: '2026-10-30', title: 'Dussehra (Vijaya Dashami)', type: 'Holiday' },
  // November 2026
  { date: '2026-11-08', title: 'Diwali (Deepawali) – Vacation Begins', type: 'Holiday' },
  { date: '2026-11-13', title: 'School Reopens After Diwali', type: 'Academic' },
  { date: '2026-11-14', title: "Children's Day Celebration", type: 'Event' },
  { date: '2026-11-24', title: 'Guru Nanak Jayanti', type: 'Holiday' },
  // December 2026
  { date: '2026-12-25', title: 'Christmas – Winter Vacation Begins', type: 'Holiday' },
  // January 2027
  { date: '2027-01-01', title: 'School Reopens After Winter Break', type: 'Academic' },
  { date: '2027-01-14', title: 'Makar Sankranti / Lohri', type: 'Holiday' },
  { date: '2027-01-26', title: 'Republic Day Celebration', type: 'Event' },
  // February 2027
  { date: '2027-02-17', title: 'Maha Shivratri', type: 'Holiday' },
  // March 2027
  { date: '2027-03-22', title: 'Holi', type: 'Holiday' },
  { date: '2027-03-31', title: 'Academic Session Ends', type: 'Academic' },
];

export default function AcademicCalendar() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState('All');
  const [session, setSession] = useState('2025-26');

  useEffect(() => {
    axios.get(process.env.REACT_APP_CALENDAR_API)
      .then((res) => setEvents(res.data || []))
      .catch(() => setEvents([...events2526, ...events2627]))
      .finally(() => setLoading(false));
  }, []);

  const sessionEvents = session === '2025-26' ? events2526 : events2627;
  const displayEvents = events.length > 0
    ? events.filter((e) => {
        const year = new Date(e.date).getFullYear();
        return session === '2025-26' ? year <= 2026 && new Date(e.date) < new Date('2026-04-01') : year >= 2026 && new Date(e.date) >= new Date('2026-04-01');
      })
    : sessionEvents;

  const types = ['All', 'Academic', 'Holiday', 'Exam', 'Event', 'PTM'];
  const filtered = activeFilter === 'All'
    ? displayEvents
    : displayEvents.filter((e) => e.type === activeFilter);

  return (
    <Layout bannerTitle="Academic Calendar">
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <LineSeperator title={`Academic Calendar ${session}`} />

          {/* Session Year Switcher */}
          <div className="cal-session-bar mt-4">
            {['2025-26', '2026-27'].map((s) => (
              <button
                key={s}
                className={`cal-session-btn${session === s ? ' active' : ''}`}
                onClick={() => { setSession(s); setActiveFilter('All'); }}
              >
                {s}
              </button>
            ))}
          </div>

          <div className="cal-filter-bar mt-3">
            {types.map((t) => (
              <button
                key={t}
                className={`cal-filter-btn${activeFilter === t ? ' active' : ''}`}
                onClick={() => setActiveFilter(t)}
              >
                {t}
              </button>
            ))}
          </div>
          {loading ? (
            <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
          ) : (
            <div className="cal-events-table mt-4">
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Date</th>
                      <th>Event / Activity</th>
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.map((ev, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{moment(ev.date).format('DD MMM YYYY')}</td>
                        <td>{ev.title}</td>
                        <td><span className={`cal-type-badge type-${ev.type?.toLowerCase()}`}>{ev.type}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}
